<template>
  <div class="dispatch_page">
    <b-breadcrumb :items="breadCrumbs" />
    <b-alert show variant="success" v-if="success">{{ success }}</b-alert>
    <b-btn
      variant="success"
      size="lg"
      class="float-right mb-3"
      @click="dispatch"
      v-if="orders && orders.length"
      >Dispatch</b-btn
    >
    <b-btn
      variant="warning"
      size="lg"
      class="float-right mb-3 mr-2"
      @click="files"
      v-if="BRAND == 'IM'"
      >Files</b-btn
    >
    <b-row v-if="!orders || orders.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No Orders to dispatch. Yay!</b-alert>
      </b-col>
    </b-row>
    <b-form-checkbox
      class="float-left"
      v-model="selectAll"
      @change="markAll"
      v-if="orders && orders.length"
      >{{ selectAll ? "Unselect All" : "Select all" }}</b-form-checkbox
    >
    <b-table
      :striped="true"
      v-if="orders && orders.length"
      :items="orders"
      :fields="fields"
    >
      <template slot="cell(HEAD_order_id)" slot-scope="data">
        <em>{{ data.label }}</em>
      </template>
      <template slot="cell(check_box)" slot-scope="row">
        <b-form-checkbox
          :id="'mark_' + row.item.order_id"
          v-model="row.item.marked"
        ></b-form-checkbox>
      </template>
      <template slot="cell(order_id)" slot-scope="row">
        {{ row.item.order_id }}
        <!-- <b-badge class="text-center" variant="warning" v-if="!row.item.complete"
          >Partially Picked</b-badge
        > -->
      </template>

      <!-- <template slot="cell(actions)" slot-scope="row">
        <b-btn variant="warning" size="sm" @click="editWeight(row.item)"
          >Edit Weight</b-btn
        >
      </template> -->
    </b-table>
    <files-modal ref="filesModal"></files-modal>
    <edit-weight-modal
      ref="editWeightModal"
      :editOrder="editOrder"
      @weightUpdated="getDispatchOrders"
    ></edit-weight-modal>
  </div>
</template>

<script>
import FilesModal from "@/components/dispatch/FilesModal.vue";
import EditWeightModal from "@/components/dispatch/EditWeightModal.vue";
export default {
  name: "shopify-dispatch",
  components: {
    FilesModal,
    EditWeightModal
  },
  data() {
    return {
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Dispatch", active: true }
      ],
      success: "",
      orders: null,
      selectAll: false,
      editOrder: null,
      fields: [
        { key: "check_box", label: "", sortable: true },
        { key: "order_id", label: "#", sortable: true },
        { key: "shopify_order_id", label: "Shopify Order" },
        { key: "created_at", label: "Date" },
        { key: "actions", label: "" }
      ]
    };
  },
  mounted: function() {
    this.getDispatchOrders();
  },
  methods: {
    rowClass: function(shippingMethod) {
      return shippingMethod.toLowerCase().includes("express")
        ? "bg-danger text-white shipping-red"
        : "";
    },
    getDispatchOrders() {
      let loader = this.$loading.show();
      //TODO add brand back to URL when dispatch is brand based
      this.$http.get(this.APIURL + this.BRAND + "/dispatch").then(
        response => {
          this.orders = response.data;
          this.orders.forEach((order, idx) => {
            order.marked = false;
          });
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    files() {
      this.$refs.filesModal.showModal();
    },
    markAll(checked) {
      this.orders = this.orders.map(order => {
        order.marked = checked;
        return order;
      });
    },
    dispatch() {
      this.success = "";
      let dispatchOrders = [];
      let dispatchOrderIds = [];
      this.orders.forEach(order => {
        if (order.marked) {
          dispatchOrders.push(order);
          dispatchOrderIds.push(order.order_id);
        }
      });

      if (dispatchOrders.length > 0) {
        let loader = this.$loading.show();
        this.$http
          .post(this.APIURL + this.BRAND + "/dispatch-order", {
            orders: JSON.stringify(dispatchOrders)
          })
          .then(
            response => {
              if (response.data.status == "success") {
                this.success = "Orders Dispatched successfully!";
                let filteredOrders = this.orders.filter(function(order) {
                  return dispatchOrderIds.indexOf(order.order_id) == -1;
                });
                this.orders = filteredOrders;
                this.selectAll = false;
                loader.hide();
              }
            },
            error => {
              console.log(error);
            }
          );
      } else {
        alert("No orders are selected for dispatch");
      }
    },
    editWeight(order) {
      this.editOrder = order;
      this.$refs.editWeightModal.showModal();
    }
  }
};
</script>
